import { ReactNode } from 'react';

export type ButtonViewProps = {
  isActive: boolean;
  isDisabled: boolean;
  children: ReactNode;
};

export enum ButtonType {
  Transparent,
  Primary,
  CreateTicket,
  Arrow,
  ChatTab,
}
